module.exports = __webpack_public_path__ + "static/media/VectorNo.578e796c.svg";